import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Spin } from '@arco-design/web-react';
import type { GlobalState } from '@/store';
import { hasAuthMarkerCookie } from '@/utils/authSession';
import styles from '@/style/layout.module.less';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/** 仅校验登录态；无业务权限的用户仍可进入布局（个人中心） */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const hydrated = useSelector((state: GlobalState) => state.hydrated);
  const user = useSelector((state: GlobalState) => state.user);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (hydrated) {
      setChecking(false);
    }
  }, [hydrated]);

  if (checking || !hydrated) {
    return (
      <div className={styles.spin}>
        <Spin size={32} />
      </div>
    );
  }

  if (!hasAuthMarkerCookie() || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
